export const getPlaceholderImage = (text, width = 300, height = 400) => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
    <rect width="100%" height="100%" fill="#1e293b"/>
    <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
          font-family="Inter,sans-serif" font-size="16" fill="#94a3b8">${text}</text>
  </svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
